<template>
  <div class="row col-12 justify-between">
    <div class="column col-5">
      <p class="text-body1 text-grey-8">
        Pesquisa de {{ entity }}
      </p>
      <q-input
        v-model="searchWord"
        :for="id"
        class="col-5"
        :loading="isLoading"
        filled
        :placeholder="`Procure por ${entity} e pressione enter`"
        @keyup.enter="$emit('typing', searchWord)"
      >
        <template v-slot:append>
          <q-icon name="search" />
        </template>
      </q-input>
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'SearchBox',
  props: {
    entity: { type: String, default: 'Entity' },
    isLoading: { type: Boolean, default: false },
    id: { type: String, default: 'searchWord' },
  },
  data: () => ({
    searchWord: '',
  }),
};
</script>
